import React from 'react';
import CreateServiceOrderLayout from "../components/administration/CreateServiceOrderLayout";

function CreateServiceOrderPage() {

  return <CreateServiceOrderLayout />;
}

export default CreateServiceOrderPage;
